export default __webpack_public_path__ + "static/media/model-tab-icon.c50b4fc4.svg";